import { render, staticRenderFns } from "./triggerTheSettings.vue?vue&type=template&id=64831034&scoped=true&"
import script from "./triggerTheSettings.vue?vue&type=script&lang=js&"
export * from "./triggerTheSettings.vue?vue&type=script&lang=js&"
import style0 from "./triggerTheSettings.vue?vue&type=style&index=0&id=64831034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64831034",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64831034')) {
      api.createRecord('64831034', component.options)
    } else {
      api.reload('64831034', component.options)
    }
    module.hot.accept("./triggerTheSettings.vue?vue&type=template&id=64831034&scoped=true&", function () {
      api.rerender('64831034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/SingleRule/triggerTheSettings.vue"
export default component.exports